import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildSeo, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/about")({
  head: () => {
    const seo = buildSeo({
      title: "About Us | Bazar 3D — Space Design Studio",
      description:
        "Meet the Bazar 3D team — a Saudi studio specialized in interior and 3D design. 250+ delivered projects across residential, commercial, and hospitality.",
      keywords: "about us, Bazar 3D, interior design, 3D design, Saudi studio, space design",
      path: "/about",
    });
    return {
      meta: seo.meta,
      links: seo.links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "About", path: "/about" },
            ]),
          ),
        },
      ],
    };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/about")),
});